
import { LoginConsts } from 'client/util/Constants';
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';
import EmailBadge from 'client/components/EmailBadge.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';

import UserLoginStore from 'client/stores/UserLoginStore';

const { mfaDirectResetNoFactors } = LoginConsts.responseMessages;

export default defineComponent({
  name: 'UserResetPasswordNoFactors',

  components: {
    EmailBadge,
    LoginActionButton,
    LoginCard,
  },

  props: {
    message: {
      type: String,
      default: mfaDirectResetNoFactors,
    },
  },

  computed: {
    ...mapStores(UserLoginStore),

    email() {
      return this.userLoginStore.email;
    },
  },

  methods: {
    goToLogin() {
      this.$emit('goToLogin');
    },
  },
});
